export const getTaxesId = (key: number, field: string, tableKey?: number) => {
  const taxesTableFields = new Set(['to', 'from', 'tax', 'repeat']);
  if (taxesTableFields.has(field)) {
    return `taxes-${key}-table-${tableKey}-${field}`;
  }
  return `taxes-${key}-${field}`;
};
